<template>
    <div>
      <chanpin  page_type="1" user_type="1"  chanpin_type="4"  xiugai_type="1"> </chanpin> 
    </div>
  </template>
  <script>
  import chanpin from '../../tongyong/zuheShangpin.vue'
   
  export default {
  
    components: {
      chanpin: chanpin 
    },
  
    data() {
      return {
        // 获取用户列表参数
        
      };
    },
    props: [],
   
    watch: {
   
    },
    created() {
   
    },
    mounted() {
   
    }
  }
  </script>
